export const validateDecimal = {
  validate: (value: string) => {
    const int = parseInt(value.toString(), 10);
    const isNumber = !Number.isNaN(int);
    const hasDecimal = value.toString().includes('.');
    const isPositive = !!(isNumber === true && int >= 0);

    if (isNumber && !hasDecimal && isPositive) {
      return true;
    }

    return 'Value must be in Cents (no decimal or negative numbers)';
  },
};

export const validateDecimalAndPositive = {
  validate: (value: string) => {
    const int = parseInt(value.toString(), 10);
    const isNumber = !Number.isNaN(int);
    const hasDecimal = value.toString().includes('.');
    const isPositive = !!(isNumber === true && int > 0);

    if (isNumber && !hasDecimal && isPositive) {
      return true;
    }

    return 'Value must be in Cents (no decimals and must be positive number)';
  },
};

export function toNumber(value: string | number) {
  // absolute value ensures positive number
  // a negative number should never be inputted, its just a backup.
  return Math.abs(parseFloat(value.toString()));
}
